import { Typography } from '@material-ui/core'

import { persianRegex } from '../../../../helpers/regex'
import { getTranslate } from '../../../../localization'
import { SourceInfoType } from '../../../../types/bookingDetails'
import { useStyles } from './styles/index.styles'

type Props = {
  data: SourceInfoType | undefined
}

const SourceInfo = ({ data }: Props) => {
  const classes = useStyles()
  const isPersianName = persianRegex.test(data?.name || '')

  return (
    <div className={classes.container}>
      <div className={classes.top}>
        <Typography variant="h4" className={classes.title}>
          {getTranslate('Source Info')}
        </Typography>
      </div>
      <div className={classes.divider} />
      <div className={classes.bottom}>
        <div className={classes.row}>
          <Typography variant="h5" className={classes.text}>
            {getTranslate('Source Name')}
          </Typography>
          <Typography
            variant="h5"
            className={classes.text}
            style={isPersianName ? { fontFamily: 'IranSans' } : undefined}>
            {data?.name}
          </Typography>
        </div>
        <div className={classes.row}>
          <Typography variant="h5" className={classes.text}>
            {getTranslate('Source Code')}
          </Typography>
          <Typography variant="h5" className={classes.text}>
            {data?.code}
          </Typography>
        </div>
        <div className={classes.row}>
          <Typography variant="h5" className={classes.text}>
            {getTranslate('Source Reservation Num')}
          </Typography>
          <Typography variant="h5" className={classes.text}>
            {data?.reservationNumber || '-'}
          </Typography>
        </div>
      </div>
    </div>
  )
}

export default SourceInfo
